export default {
  props: ['label', 'position', 'border-radius'],
  data() {
    return {
      privateKey: '',
    };
  },
  methods: {
    getHash() {
      if (this.privateKey !== '') {
        this.showPrivateAlbumModal(this.privateKey);
      }
    }
  },
};
